import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/onboarding/Onboarding.css';

const OnboardingIntro = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();

  const handleGetStarted = () => {
    // Navigate to the first step of the onboarding process
    navigate(`/group/${groupId}/onboarding/identity`);
  };

  // Icons with colorful and 3D styling
  const verifyIcon = (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#E8EDFF" />
      <rect x="12" y="12" width="36" height="36" rx="4" fill="#5669FF" />
      <path d="M22 29.5L27 34.5L38 23.5" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="30" cy="17" r="3" fill="#FF5252" />
    </svg>
  );

  const profileIcon = (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#E1F5FE" />
      <rect x="12" y="12" width="36" height="36" rx="4" fill="#29B6F6" />
      <path d="M20 20H40" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 27H40" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 34H30" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <circle cx="40" cy="40" r="8" fill="#4CAF50" />
      <path d="M36 40L39 43L44 38" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const communityIcon = (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="8" fill="#FFF3E0" />
      <rect x="12" y="12" width="36" height="36" rx="4" fill="#FF9800" />
      <circle cx="25" cy="25" r="5" fill="white" />
      <circle cx="38" cy="25" r="3" fill="white" />
      <circle cx="25" cy="38" r="3" fill="white" />
      <circle cx="38" cy="38" r="5" fill="white" />
      <rect x="28" y="22" width="7" height="2" rx="1" fill="#FF9800" />
      <rect x="22" y="28" width="7" height="2" rx="1" fill="#FF9800" />
      <rect x="35" y="35" width="7" height="2" rx="1" fill="#FF9800" />
    </svg>
  );

  return (
    <div className="onboarding-container">
      <div className="onboarding-content">
        <h1 className="intro-title">It's easy to get verified with Yesod</h1>
        
        <div className="onboarding-step-container">
          {/* Step 1: Verify Identity */}
          <div className="onboarding-step">
            <div className="step-content">
              <div className="step-number">1</div>
              <div className="step-title">Verify your Identity</div>
              <div className="step-description">
                Share some basic info, such as your name and address
                <br />(15 seconds)
              </div>
            </div>
            <div className="step-icon">
              {verifyIcon}
            </div>
          </div>

          {/* Step 2: Create Profile */}
          <div className="onboarding-step">
            <div className="step-content">
              <div className="step-number">2</div>
              <div className="step-title">Create your Profile</div>
              <div className="step-description">
                Tell your shul about important dates
                <br />(30 seconds)
              </div>
            </div>
            <div className="step-icon">
              {profileIcon}
            </div>
          </div>

          {/* Step 3: Join Community */}
          <div className="onboarding-step">
            <div className="step-content">
              <div className="step-number">3</div>
              <div className="step-title">Join your Community</div>
              <div className="step-description">
                See what's happening in your community space, enjoy classes, events and more
              </div>
            </div>
            <div className="step-icon">
              {communityIcon}
            </div>
          </div>
        </div>
      </div>
      
      {/* Get Started button moved to the bottom */}
      <div className="onboarding-bottom-button">
        <button className="get-started-button" onClick={handleGetStarted}>
          Get started
        </button>
      </div>
    </div>
  );
};

export default OnboardingIntro;